<div class="fadein animation-duration-500 flex align-items-center gap-2 mb-1">
  <div class="w-auto md:w-6 lg:w-6">
    <p-iconField iconPosition="left">
      <p-inputIcon>
        <i class="pi pi-search"></i>
      </p-inputIcon>
      <input
        #inputElement
        pInputText
        type="text"
        placeholder="Buscar por Reclamante, Reclamado, Nº de reclamo o Nº de expediente"
        class="w-full"
        [(ngModel)]="generalFilter"
        (input)="applyFilters()"
      />
    </p-iconField>
  </div>
  <p-button
    (onClick)="op.toggle($event)"
    icon="pi pi-sliders-h icon-filter"
    label="Filtros"
  />
  <p-overlayPanel
    showTransitionOptions=".50s cubic-bezier(0, 0, 0.2, 1)"
    appendTo="body"
    #op
    (onHide)="hasFilters() ? applyFilters() : false"
  >
    <ng-template pTemplate="content">
      <div class="flex flex-column gap-4">
        <div *ngIf="viewStatus" class="flex flex-column">
          <label class="label-bold">Estado</label>
          <div
            class="flex flex-row justify-content-between align-items-center gap-2"
          >
            <div class="w-full">
              <p-multiSelect
                [options]="stateList"
                [(ngModel)]="selectedStates"
                placeholder="Seleccione el estado"
                filter="false"
                styleClass="w-full"
              >
                <ng-template let-status pTemplate="item">
                  {{ status | claimStatusDisplay }}
                </ng-template>
              </p-multiSelect>
            </div>
            <div class="flex align-items-center gap-1">
              <i
                class="pi-filter-class pi pi-sort-alpha-down pr-2"
                [ngClass]="{ 'pi-filter-active': statusOrder === 1 }"
                (click)="orderSelect('status', 1)"
                title="Ordenar por estado ascendente"
              ></i>
              <i
                class="pi-filter-class pi pi-sort-alpha-down-alt"
                [ngClass]="{ 'pi-filter-active': statusOrder === 2 }"
                (click)="orderSelect('status', 2)"
                title="Ordenar por estado descendente"
              ></i>
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-column w-full">
            <label class="label-bold" for="">Fecha de Inicio</label>
            <div
              class="flex flex-row justify-content-between align-items-center gap-2"
            >
              <p-calendar
                [(ngModel)]="selectedDate"
                [iconDisplay]="'input'"
                [showIcon]="true"
                dateFormat="dd/mm/yy"
                inputId="icondisplay"
                placeholder="Seleccione la fecha de inicio"
                styleClass="w-full"
              />
              <div class="flex align-items-center gap-1">
                <i
                  class="pi-filter-class pi pi-sort-numeric-down pr-2"
                  [ngClass]="{ 'pi-filter-active': dateOrder === 1 }"
                  (click)="orderSelect('date', 1)"
                  title="Ordenar por fecha ascendente"
                ></i>
                <i
                  class="pi-filter-class pi pi-sort-numeric-down-alt"
                  [ngClass]="{ 'pi-filter-active': dateOrder === 2 }"
                  (click)="orderSelect('date', 2)"
                  title="Ordenar por fecha descendente"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            this.userId !== 'Trabajador' &&
            this.userId !== 'Empleador' &&
            this.userId !== 'Conciliador'
          "
        >
          <div class="flex flex-column w-full">
            <label class="label-bold">Departamento de Santa Fe</label>
            <div
              class="flex flex-row justify-content-between align-items-center gap-2"
            >
              <p-dropdown
                [options]="departmentList"
                [(ngModel)]="selectedDepartment"
                optionValue="department_number"
                optionLabel="name"
                placeholder="Seleccione el departamento"
                emptyMessage="Sin resultados"
                filter="false"
                styleClass="w-full"
              />
              <div class="flex align-items-center gap-1">
                <i
                  class="pi-filter-class pi pi-sort-alpha-down pr-2"
                  [ngClass]="{ 'pi-filter-active': departamentOrder === 1 }"
                  (click)="orderSelect('departament', 1)"
                  title="Ordenar por departamento ascendente"
                ></i>
                <i
                  class="pi-filter-class pi pi-sort-alpha-down-alt"
                  [ngClass]="{ 'pi-filter-active': departamentOrder === 2 }"
                  (click)="orderSelect('departament', 2)"
                  title="Ordenar por departamento descendente"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="
            this.userId !== 'Trabajador' &&
            this.userId !== 'Empleador' &&
            this.userId !== 'Conciliador'
          "
        >
          <div class="flex flex-column w-full">
            <label class="label-bold">Conciliador</label>
            <div
              class="flex flex-row justify-content-between align-items-center gap-2"
            >
              <div class="w-full">
                <p-dropdown
                  [options]="conciliatorList"
                  [(ngModel)]="selectedconciliator"
                  optionValue="id"
                  optionLabel="name"
                  placeholder="Seleccione el conciliador"
                  emptyMessage="Sin resultados"
                  filter="false"
                  styleClass="w-full"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    <span style="text-align: end">
                      {{
                        selectedOption.name +
                          " " +
                          (selectedOption.last_name
                            ? selectedOption.last_name
                            : "") | truncate
                      }}
                    </span>
                  </ng-template>
                  <ng-template let-state pTemplate="item">
                    <span [ngClass]="{ 'no-assigned-option': !state.id }">
                      {{
                        state.name +
                          " " +
                          (state.last_name ? state.last_name : "") | truncate
                      }}
                    </span>
                  </ng-template>
                </p-dropdown>
              </div>
              <div class="flex align-items-center gap-1">
                <i
                  title="Ordenar por conciliador ascendente"
                  class="pi-filter-class pi pi-sort-alpha-down pr-2"
                  [ngClass]="{ 'pi-filter-active': conciliatorOrder === 1 }"
                  (click)="orderSelect('conciliator', 1)"
                ></i>
                <i
                  title="Ordenar por conciliador descendente"
                  class="pi-filter-class pi pi-sort-alpha-down-alt"
                  [ngClass]="{ 'pi-filter-active': conciliatorOrder === 2 }"
                  (click)="orderSelect('conciliator', 2)"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="flex align-items-center gap-3">
          <label class="label-bold">Número de reclamo</label>
          <div class="flex align-items-center gap-1">
            <i
              title="Ordenar por número de reclamo ascendente"
              class="pi-filter-class pi pi-sort-numeric-down pr-2"
              [ngClass]="{ 'pi-filter-active': claimNumberOrder === 1 }"
              (click)="orderSelect('claimNumber', 1)"
            ></i>
            <i
              title="Ordenar por número de reclamo descendente"
              class="pi-filter-class pi pi-sort-numeric-down-alt"
              [ngClass]="{ 'pi-filter-active': claimNumberOrder === 2 }"
              (click)="orderSelect('claimNumber', 2)"
            ></i>
          </div>
        </div>
      </div>
      <div class="container-buttons">
        <button class="btn-light cancel" (click)="cleanFilter()">
          Limpiar filtros
        </button>
        <button class="btn-plus" (click)="applyFilters()">
          Aplicar filtros
        </button>
      </div>
    </ng-template>
  </p-overlayPanel>
  <button
    class="btn-clean"
    *ngIf="hasFilters()"
    title="Limpiar filtros"
    (click)="cleanFilter()"
  >
    <i class="pi pi-times"></i>
  </button>
  <small *ngIf="hasFilters()" class="ml-1 text-red-400"
    >* Tiene filtros aplicados</small
  >
</div>
